import { render } from "./VF-button.vue?vue&type=template&id=4d97af54"
import script from "./VF-button.vue?vue&type=script&lang=js"
export * from "./VF-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__